import React from 'react';
import { connect } from 'react-redux';
import { actions, deleteConfirmationActions, optionsMenuActions } from '../../../actions';

class OptionsMenu extends React.Component {

  constructor(props) {
    super(props);
    this.editClicked = this.editClicked.bind(this);
    this.deleteClicked = this.deleteClicked.bind(this);
  }

  endpoint() {
    let endpoint;
    if (this.props.optionsMenu.parentType === 'Comment') {
      endpoint = routes().comments + this.props.optionsMenu.parentId;
    } else if (this.props.optionsMenu.parentType === 'TsukkomiComment') {
      endpoint = routes().post_tsukkomi_comment + '/' + this.props.optionsMenu.parentId;
    } else if (this.props.optionsMenu.parentType === 'PopCommentReply') {
      endpoint = routes().comment_replies + '/' + this.props.optionsMenu.parentId;
    }
    return endpoint;
  }

  editClicked() {
    this.props.openUpdateForm(Object.assign({}, this.props.optionsMenu, {
      body: this.props.body,
      endpoint: this.endpoint()
    }));
  }

  deleteClicked() {
    this.props.deleteConfirmationOpen(this.props.deleteConfirmationSetup);
  }

  render = () => (
    <div className="f--3 shadow-1 absolute bg-white" style={{top: '24px', right: '10px'}}>
      <ul className="t-pa0 t-pv1 t-ma0 list ttu black-60 fw4">
        <li
          className="a-lh2 t-pl2 t-pr4 pointer hover-bg-purple hover-white"
          onClick={this.editClicked}
        >
          {I18n.t('common.edit')}
        </li>
        <li
          className="a-lh2 t-pl2 t-pr4 pointer hover-bg-purple hover-white"
          onClick={this.deleteClicked}
        >
          {I18n.t('common.delete')}
        </li>
      </ul>
    </div>
  )
}

const mapState = state => ({
  optionsMenu: state.optionsMenu,
  cutted: state.current_episode_comments.filter(c =>
    c.id == state.optionsMenu.commentedId &&
    c.comment_type == state.optionsMenu.commentedType &&
    c.pop_comment_replies_count > c.replies.length
  ).length > 0,
  deleteConfirmationSetup: state.optionsMenu
});

const mapDispatch = dispatch => ({
  openUpdateForm: (updateForm) => {
    dispatch(optionsMenuActions.closeOptionsMenu());
    dispatch(actions.closeReplyForm());
    dispatch(deleteConfirmationActions.deleteConfirmationClose());
    dispatch(actions.openUpdateForm(updateForm));
  },
  deleteConfirmationOpen: (deleteConfirmationSetup) => {
    dispatch(optionsMenuActions.closeOptionsMenu());
    dispatch(actions.closeUpdateForm());
    dispatch(actions.closeReplyForm());
    dispatch(deleteConfirmationActions.deleteConfirmationOpen(deleteConfirmationSetup));
  }
});

export default connect(mapState, mapDispatch)(OptionsMenu);
